import React from "react";
import "./ForgotPassword.css";
import FormImage from "../../Assets/images/login.png";
import ForgotPasswordViewModel from "./ForgotPasswordViewModel";
import ButtonSpinner from "../../Components/Spinners/ButtonSpinner";
import { ToastContainer } from "react-toastify";

const ForgotPassword = () => {
  const [
    email,
    setEmail,
    ResetPassword,
    EmailError,
    IsPasswordResetEmailSend,
    BtnLoader,
  ] = ForgotPasswordViewModel();

  console.log("IsPasswordResetEmailSend", IsPasswordResetEmailSend);
  return (
    <div className="main-wrapper login-body">
      <ToastContainer />
      <div className="login-wrapper">
        <div className="container">
          <div className="loginbox">
            <div className="login-left">
              <img className="img-fluid" src={FormImage} alt="Logo" />
            </div>
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>Forgot Password</h1>
                <p className="account-subtitle">Let Us Help You</p>
                {/* Form */}
                <form>
                  <p>Enter your register email to get a password reset link.</p>
                  <div className="form-group">
                    <label>
                      Email <span className="login-danger">*</span>
                    </label>
                    <input
                      className={`form-control ${
                        EmailError === true && "error-message"
                      }`}
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                    {EmailError === true ? (
                      <span className="login-tooltip">
                        <i className="fa-solid fa-info icon-after-submit"></i>
                        <span className="text-after-submit">
                          Email is required. xyz@gmail.com
                        </span>
                      </span>
                    ) : (
                      <span className="login-tooltip">
                        <i className="fa-solid fa-info text-info"></i>
                        <span className="login-tooltip-text">
                          Email is required. xyz@gmail.com
                        </span>
                      </span>
                    )}
                  </div>

                  {IsPasswordResetEmailSend && (
                    <p className="password-rest-success-text">
                      Password reset link is send to your email.check your email
                      to reset password.
                    </p>
                  )}
                  <div className="form-group">
                    <button
                      className="btn btn-primary btn-block"
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        ResetPassword();
                      }}
                    >
                      {BtnLoader && <ButtonSpinner />}
                      &nbsp;
                      {IsPasswordResetEmailSend ? "Resend" : " Send link"}
                    </button>
                  </div>
                  <div className="form-group mb-0"></div>
                </form>
                {/* /Form */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
